import { CreatePriceDto } from '@sr/dto';
import { mediaPriceApi } from './api';
type Optional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

type GetQuery = {
    mediaId: number,
    searchParams?: URLSearchParams,
    options?: {
        isActive?: boolean | null;
    }
}
export const useMediaPrices = (params: GetQuery) => {
  const { isLoading, data, error } = mediaPriceApi.useGetMediaPricesQuery(params);
  return {
    isLoading,
    error,
    items: isLoading ? [] : data
  };
};

export const useAddMediaPrice = () => {
  const [create] = mediaPriceApi.useAddMediaPriceMutation();
  return (dto: Optional<CreatePriceDto, 'mainFile'>) => create(dto).unwrap();
};

export const useDeactivatePrice = () => {
  const [fn] = mediaPriceApi.useDeactivatePriceMutation();
  return (priceId: number) => fn(priceId).unwrap();
};

export const useDeletePrice = () => {
  const [fn] = mediaPriceApi.useDeletePriceMutation();
  return (priceId: number) => fn(priceId).unwrap();
};
